/*
* @params num 需转换的数据
* @params n 转换后需保留的小数位数
*
* return 字符串
* */

module.exports = function (num, n = 0) {
  if (!num) {
    return '0.00'
  }
  num = Number(num)
  num = parseFloat((num + '').replace(/ [^\d\\.-] /g, '')).toFixed(n) + ''
  let l = num
    .split('.')[0]
    .split('')
    .reverse()
  let r = num.split('.')[1]
  let t = ''
  for (let i = 0; i < l.length; i++) {
    t += l[i] + ((i + 1) % 3 === 0 && i + 1 !== l.length ? ',' : '')
  }
  if (n === 0) {
    /*返回形式1,000*/
    return t
      .split('')
      .reverse()
      .join('')
  } else {
    return (
      t
        .split('')
        .reverse()
        .join('') +
      '.' +
      r
    )
    //返回形式1,000.00
  }
}



// WEBPACK FOOTER //
// ./src/config/numToThousand.js